import {UI} from "../../../stem-core/src/ui/UIBase.js";
import {StyleSheet} from "../../../stem-core/src/ui/Style.js";

import {StepDescription} from "./StepDescription.jsx";
import {authService} from "../../../client/connection/Services.js";
import {DONATE_PAGE_URLS} from "../PanelConstants.js";
import {Messages} from "../../Messages.js";
import {PanelChooseCard} from "../pages/panels/donation/components/PanelChooseCard.jsx";
import {MerchantButton} from "../../common/MerchantButton.jsx";
import {PoweredByBlink} from "../PoweredByBlink.jsx";
import {Link} from "../../../stem-core/src/ui/UIPrimitives.jsx";
import {DonationStore} from "../../../client/state/DonationStore.js";
import {Flow} from "../initializeFlows.js";
import {styleRule} from "../../../stem-core/src/decorators/Style.js";
import {registerStyle} from "../../../stem-core/src/ui/style/Theme.js";
import {iFrameUserDataService} from "../../services/IFrameUserDataService.js";
import {Controller} from "../Controller.js";


class EditChooseCardPanelStyle extends StyleSheet {
    @styleRule
    title = this.themeProps.PANEL_TITLE;

    @styleRule
    back = this.themeProps.PANEL_LINK;

    @styleRule
    center = {
        margin: "20px 0",
        textAlign: "center",
    };
}

@registerStyle(EditChooseCardPanelStyle)
export class EditChooseCardPanel extends UI.Element {
    static initialPaymentMethod = null;

    getDonation() {
        return iFrameUserDataService.getActiveRecurringDonation();
    }

    render() {
        const {styleSheet} = this;

        return [
            <StepDescription backFunction={() => this.options.changeURL(authService.isAuthenticated() ?
                DONATE_PAGE_URLS.donate : DONATE_PAGE_URLS.auth, true)}
                             currentStep={StepDescription.stepCount} stepDescription={Messages.paymentStep}/>,
            <div className={styleSheet.title}>{Messages.paymentDetails}</div>,
            <PanelChooseCard hideActiveCard={true} addCardButtonLabel={Messages.addNewCard} ref="chooseCard"
                             selected={Controller.paymentMethod.selectedPaymentMethod}
                             onAddCard={() => this.options.changeURL(DONATE_PAGE_URLS.editAddCard)}
                             onCardSelected={card => {
                                   Controller.paymentMethod.selectedPaymentMethod = card;
                                   this.redraw();
                               }}
                             recurringPayment={this.getDonation()}/>,
            <MerchantButton disabled={this.chooseCard && !this.chooseCard.getActive()}
                            onClick={() => this.continue()}>
                {Messages.updatePaymentMethod}
            </MerchantButton>,
            <div className={styleSheet.center}>
                <Link value={Messages.back} className={styleSheet.back}
                      onClick={() => {
                          Flow.donation.updateEditDonationPaymentMethod(this.constructor.initialPaymentMethod);
                          this.redraw();
                          this.options.changeURL(DONATE_PAGE_URLS.editDonation, true)
                      }}/>
            </div>,
            <PoweredByBlink />,
        ];
    }

    continue() {
        Flow.donation.updateEditDonationPaymentMethod(this.chooseCard.getActive());
        this.options.changeURL(DONATE_PAGE_URLS.editDonation, true);
    }

    onMount() {
        this.attachChangeListener(DonationStore, () => {
            if (this.isInDocument() && !this.getDonation()) {
                this.options.changeURL(DONATE_PAGE_URLS.donate, true);
            }
        });
    }
}
